<template>
    <networks-provider
        v-slot="{
            campaign,
            contact,
            proposal,
            networkId,
            forceReloadContact,
            handleConnectInstagram,
            connectionSource
        }"
        style="height: 100%"
    >
        <connect-network-view
            :campaign="campaign"
            :proposal="proposal"
            :contact-id="contact.id"
            :network-id="networkId"
            :connection-source="connectionSource"
            @load-contact="forceReloadContact"
            @connect-instagram="handleConnectInstagram"
        />
    </networks-provider>
</template>

<script>
    import ConnectNetworkView from '../data-views/networks/ConnectNetworkView.vue';
    import NetworksProvider from '../providers/proposal-steps/NetworksProvider.vue';
    export default {
        name: 'ConnectNetworkRouterView',
        components: {
            NetworksProvider,
            ConnectNetworkView
        }
    };
</script>
